import PropTypes from "prop-types";
import React, { useEffect,useState } from "react";


import { Button, Row, Col, CardBody, Card, Alert, Container, Form, Input, FormFeedback, Label,Modal,ModalHeader } from "reactstrap";


import { Link } from "react-router-dom";
import withRouter from "../../components/Common/withRouter";
import {ToastContainer,toast} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useNavigate } from 'react-router-dom';
const Register = props => {
    document.title = "Login | Easybox";
   
     const[email, setEmail] = useState('');
     const[password, setPassword] = useState('')
     const navigate = useNavigate();
     const[modal, setModal] = useState('')
     const[newPassword,setNewpassword] = useState('');
     const[confirmPassword, setConfirmpassword] = useState('');
     const[role, setRole] = useState('')
     const[step, setStep] = useState(1)
     const[storeId, setStoreid] = useState('')
     const[storename, setStorename] = useState('')
     const[phone, setPhone] = useState('')
     const[registration, setRegistration] = useState('')
     const [formattedCoordinates, setFormattedCoordinates] = useState("");
     const [searchQuery, setSearchQuery] = useState("");
     const [suggestions, setSuggestions] = useState([]);
     const [selectedLocation, setSelectedLocation] = useState(null);
     const[submitText, setSubmittext] = useState('SIGN UP')

     
  // Fetch suggestions
  const fetchSuggestions = async (query) => {
    if (!query) {
      setSuggestions([]);
      return;
    }
    const response = await fetch(
      `https://nominatim.openstreetmap.org/search?q=${query}&format=json&addressdetails=1&limit=5`
    );
    const data = await response.json();
    setSuggestions(data);
  };

  const handleSuggestionClick = (suggestion) => {
    const location = {
      lat: parseFloat(suggestion.lat),
      lng: parseFloat(suggestion.lon),
    };

    // Format coordinates as 0000,0000
    const formatted = `${location.lat.toFixed(4)},${location.lng.toFixed(4)}`;
    // const calculatedDistance = calculateDistance(location, predefinedLocationB).toFixed(2); // Calculate distance

    setSearchQuery(suggestion.display_name); // Update the input field
    setSelectedLocation(location);
    setFormattedCoordinates(formatted); // Update formatted coordinates
    // setDistance(`${calculatedDistance}`); // Update the distance state
    setSuggestions([]); // Clear suggestions
  };


   
   
   
   
   
   
   
     useEffect(() => {
       document.body.className = "";
       // remove classname when component will unmount
       return function cleanup() {
         document.body.className = "";
       };
     });
   
     const signup =async()=>{
        const characters = 'ABCDEFGHIJKLMNOoppPQRSTUVWXYZ0123456789'; 
        let result = '';
        
        // Generate a random 8-character string
        for (let i = 0; i < 5; i++) {
        const randomIndex = Math.floor(Math.random() * characters.length);
        result += characters[randomIndex]; 
        }
        const branchID = `RDSB-${result}`;

        if(storename,phone,email,confirmPassword,password,registration){
            setSubmittext('Please wait...')
            const res = await fetch('https://easyboxstoresapi.uuidesign.xyz/api/createStore',{
                method:"POST",
                headers:{
                    "Content-Type":"application/json"
                },
                body:JSON.stringify({storename,phone,email,confirmPassword,password,formattedCoordinates,searchQuery,registration,branchID}),
                credentials:"include"
            })

            const data = await res.json();
            const {success} = data;
            if(success){
                toast.success("Store created");
                setStorename('');
                setRegistration('');
                setPhone('')
                setEmail('')
                setSearchQuery('')
                setFormattedCoordinates('');
                setPassword("")
                setConfirmpassword('');
                navigate('/login')
                setSubmittext('SIGN UP')
            }
            else{
                toast.error('Something went wrong!')
                setSubmittext('SIGN UP')
            }
        }
     }
     


  return (
    <React.Fragment>
    
    <div className="bg-overlay"></div>
    <div className="account-pages pt-5">
    <ToastContainer />
        <Container>
            <Row className="justify-content-center">
                <Col lg={6} md={8} xl={4}>
                    <Card className='mt-5'>
                        <CardBody className="p-4">
                            <div className="text-center">
                            <img src="/easyboxLogo.png" alt="" className="logo2" width={100} />
                            </div>
                            <p className="mb-5 text-center">
                                Sign up to continue to Easybox Dashboard.
                            </p>
                 
                   
                    <Row>
                      <Col md={12}>
                       

                      <div className="mb-4">
                        <Label className="form-label">Store name</Label>
                        <Input
                          name="email"
                          className="form-control"
                          placeholder="Store name"
                          type="text"
                          onChange={(e)=>{setStorename(e.target.value)}}
                          value={storename}

                        />
                        </div>
                        <div className="mb-4">
                        <Label className="form-label">Registration/ID</Label>
                        <Input
                          name="email"
                          className="form-control"
                          placeholder="Registration/ID"
                          type="text"
                          onChange={(e)=>{setRegistration(e.target.value)}}
                          value={registration}

                        />
                        </div>

                        <div className="mb-4">
                        <Label className="form-label">Email</Label>
                        <Input
                          name="email"
                          className="form-control"
                          placeholder="Enter email"
                          type="email"
                          onChange={(e)=>{setEmail(e.target.value)}}
                          value={email}

                        />
                        </div>
                        <div className="mb-4">
                        <Label className="form-label">Phone number</Label>
                        <Input
                          name="email"
                          className="form-control"
                          placeholder="Enter Phone number"
                          type="text"
                          onChange={(e)=>{setPhone(e.target.value)}}
                          value={phone}

                        />
                        </div>
                        <div style={{ position: "relative", marginBottom: "20px",width:'110%' }}>
                            <input
                            type="text"
                            value={searchQuery}
                            onChange={(e) => {
                                setSearchQuery(e.target.value);
                                fetchSuggestions(e.target.value);
                            }}
                            placeholder="Store location location"
                            className='locationInput'
                            />
                        <div
                            style={{
                                position: "absolute",
                                top: "100%",
                                left: "0",
                                background: "white",
                                border: "1px solid #ddd",
                                zIndex: 1000,
                                width: "100%",
                                maxHeight: "150px",
                                overflowY: "auto",
                            }}
                        >
                        {suggestions.map((suggestion, index) => (
                            <div
                            key={index}
                            onClick={() => handleSuggestionClick(suggestion)}
                            style={{
                                cursor: "pointer",
                                padding: "10px",
                                borderBottom: "1px solid #ddd",
                            }}
                            >
                            {suggestion.display_name}
                            </div>
                        ))}
                    </div>
                    </div>
      
                      
                        
                        <div className="mb-4">
                          <Label className="form-label">Password</Label>
                          <Input
                            name="password"
                            value={password}
                            type="password"
                            placeholder="Enter Password"
                            onChange={(e)=>{setPassword(e.target.value)}}
                           
                          />
                          
                        </div>
                        <div className="mb-4">
                          <Label className="form-label">Confirm Password</Label>
                          <Input
                            name="Confirm password"
                            value={confirmPassword}
                            type="password"
                            placeholder="Confirm Password"
                            onChange={(e)=>{setConfirmpassword(e.target.value)}}
                           
                          />
                          
                        </div>


                        <Row>
                          
                          <Col className="col-7">
                            {/* <div className="text-md-end mt-3 mt-md-0">
                              <Link
                                to="/auth-recoverpw"
                                className="text-muted"
                              >
                                <i className="mdi mdi-lock"></i> Forgot your
                                password?
                              </Link>
                            </div> */}
                          </Col>
                        </Row>
                        <div className="d-grid mt-4">
                          <button
                          style={{backgroundColor:'red',color:"white",fontWeight:"500"}}
                            className="btn waves-effect waves-light"
                            type="submit"
                            onClick={signup}
                          >
                           {submitText}
                          </button>
                        </div>
                       
                        <div className="mt-4 text-center">
                 

                      
                    </div>

                      </Col>
                    </Row>
                            
                        </CardBody>
                    </Card>
                    <div className="mt-5 text-center">
                        <p className="text-white-50">Already have an account ?<Link to="/login" className="fw-medium text-primary"> Login </Link> </p>
                        <p className="text-white-50">© {new Date().getFullYear()} Easybox. Crafted with <i className="mdi mdi-heart text-danger"></i> by Uidevlabs Technologies</p>
                    </div>
                </Col>
            </Row>
        </Container>
    </div>

</React.Fragment>
  );
};

export default Register;
